import { redirect, generatePath, LoaderFunctionArgs } from 'react-router-dom'
import { queryClient } from '@/api/react-query'
import { readUserProfile } from '@/api/user-manager'
import { listDeals } from '@/api/accounting-dealer'
import { routes } from '@/router'

export async function homeLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const searchParamToken = url.searchParams.get('token')

  if (searchParamToken) {
    localStorage.setItem('access_token', searchParamToken)
    queryClient.clear()
  }

  const token = localStorage.getItem('access_token')

  if (!token) return null

  try {
    const user = await queryClient.ensureQueryData({
      queryKey: ['user-profile'],
      queryFn: readUserProfile,
    })

    if (!user) return null

    const isEmailVerified = user.alias?.find(
      (alias) => alias.type === 'email' && alias.verified,
    )
    if (!isEmailVerified) return redirect(routes.session.confirmEmail)
    if (!user.has_password) return redirect(routes.session.createPassword)

    const deals = await queryClient.ensureQueryData({
      queryKey: ['deals'],
      queryFn: listDeals,
    })

    const activeDeals = deals.filter((deal) =>
      ['ongoing', 'incomplete'].includes(deal.status),
    )

    if (activeDeals.length === 1) {
      const deal = activeDeals[0]
      if (deal.status === 'incomplete' && deal.step !== 'signed') {
        return redirect(
          generatePath(routes.hiring.index, { deal_key: deal.key }),
        )
      }
      localStorage.setItem('selected_company', deal.company.key)
      return redirect(routes.dashboard)
    }
  } catch {
    return null
  }

  return null
}
